export enum INFO_EVENT_ENUM {
  OTP_GENERATE_SUCCESS = 'OTP_GENERATE_SUCCESS',
  OTP_CHECK_SUCCESS = 'OTP_CHECK_SUCCESS',
  LOG_IN = 'LOG_IN',
  LOG_OUT = 'LOG_OUT',
  GRPC_REQUEST = 'GRPC_REQUEST',
  GRPC_STATUS = 'GRPC_STATUS',
  GRPC_RESPONSE = 'GRPC_RESPONSE',
  GRPC_SLOW_REQUEST = 'GRPC_SLOW_REQUEST',
}

export enum ERROR_EVENT_ENUM {
  COMMON_ERROR = 'COMMON_ERROR',
  OTP_GENERATE_FAILURE = 'OTP_GENERATE_FAILURE',
  OTP_CHECK_FAILURE = 'OTP_CHECK_FAILURE',
  GRPC_RESPONSE_ERROR = 'GRPC_RESPONSE_ERROR',
  GRPC_RATE_LIMIT = 'GRPC_RATE_LIMIT',
  HTTP_RATE_LIMIT = 'HTTP_RATE_LIMIT',
  UNAUTHORISED = 'UNAUTHORISED',
  MFA_UNAUTHORISED = 'MFA_UNAUTHORISED',
  VT_UNAUTHORISED = 'VT_UNAUTHORISED',
  PAGE_NOT_FOUND = 'PAGE_NOT_FOUND',
}
